import { initializeApollo } from 'lib/apolloClient';
import { getGlobalData } from 'lib/global.js';
import { getEntityBlocks } from 'gql/common/blocks';
import { CORE_POST_FIELDS, CORE_POST_FIELDS_KEY, LATEST_100_POSTS, getPosts } from 'gql/posts';
import { GetServerSideProps, GetServerSidePropsContext, GetStaticPropsContext } from 'next';
import { Category, Post } from 'generated-graphql';
import DefaultAsset from '@/components/Series/DefaultAsset';
import Head from 'next/head';
import { cache } from '../_app';
import getResourceItemUrl from '@/helpers/resourceItemUrl';

export default function Resource({
  pageBlocks,
  seriesParts,
}: {
  pageBlocks: Post;
  seriesParts: Post[] | null;
}) {

  return (
    <>
      <DefaultAsset pageBlocks={pageBlocks} seriesParts={seriesParts} />
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext,
) => {
  const { query } = context;
  const apolloClient = initializeApollo();

  const slug = `resource/${query.slug}`;
  const cacheKey = slug;

  if (query['purge-cache'] === 'true') {
    console.log('-----> CACHE [DELETE]: cacheKey', cacheKey);
    cache.delete(cacheKey);
  }

  // Check if we have cached the page
  const cachedValue: any = cache.get(cacheKey);
  if (cachedValue) {
    // Retrieve the page from cache

    console.log(
      '-----> CACHE [HIT]: cacheKey',
      cacheKey,
      // cachedValue?.props?.pageBlocks,
    );
    return JSON.parse(cachedValue);
  }

  const pageBlocks = await apolloClient.query({
    query: getEntityBlocks('post', CORE_POST_FIELDS, CORE_POST_FIELDS_KEY),
    variables: {
      id: query.slug,
      idType: 'SLUG',
      asPreview: false,
    },
  });

  // Resource not found
  if (!pageBlocks?.data?.post?.id) {
    return {
      notFound: true,
    };
  }

  // Check if correct URL
  const correctUrl = getResourceItemUrl(pageBlocks?.data?.post);

  console.log({ correctUrl: correctUrl.url, slug: `/resources/${query.slug}`, reqUrl: context.req.url });
  if (correctUrl.url !== context.req.url) {
    return {
      redirect: {
        destination: correctUrl.url,
        permanent: true,
      },
    };
  }
  // if (pageBlocks?.data?.post?.categories?.nodes?.find((c: Category) => c.name === 'Blog')) {
  //   return {
  //     redirect: {
  //       destination: correctUrl,
  //       permanent: true,
  //     },
  //   };
  // }

  const seriesCategory =
    pageBlocks?.data?.post.categories?.nodes?.find(
      (c: Category) => c.parent?.node?.name === 'Series',
    ) || null;
  let seriesParts = null;
  if (seriesCategory) {
    seriesParts = await apolloClient.query({
      query: getPosts([seriesCategory.name]),
      variables: { first: 5 },
    });
  }

  const pageProps = {
    pageBlocks: pageBlocks?.data?.post,
    seriesParts:
      seriesParts?.data?.posts?.nodes.filter(
        (post: Post) => post.title !== pageBlocks?.data?.post.title,
      ) || null,
  };

  const retProps = await getGlobalData(pageProps, apolloClient);

  if (process.env.IS_PRODUCTION === 'true') {
    cache.set(cacheKey, JSON.stringify(retProps));
    console.log('-----> CACHE [SET]: cacheKey', cacheKey);
  }

  return retProps;
};
